import { useTranslation } from 'react-i18next';

import { SvgIcon, Tooltip } from '@mui/material';

import { ViewToggleButton, ViewToggleContainer } from './GeneratikTableToolbar.styles';

interface ToolbarViewToggleProps {
  viewMode: 'grid' | 'list';
  onViewModeChange?: (mode: 'grid' | 'list') => void;
  disabled?: boolean;
}

const ToolbarViewToggle = ({
  viewMode,
  onViewModeChange,
  disabled = false,
}: ToolbarViewToggleProps) => {
  const { t } = useTranslation();
  const tooltipSuffix = disabled ? ` (${t('available_in_data_view_only')})` : '';

  return (
    <ViewToggleContainer>
      <Tooltip title={`${t('Table view')}${tooltipSuffix}`}>
        <span>
          <ViewToggleButton
            active={viewMode === 'grid'}
            disabled={disabled}
            onClick={() => onViewModeChange?.('grid')}
            data-testid="table-view-button"
          >
            <SvgIcon viewBox="0 0 16 16" sx={{ width: '1rem', height: '1rem' }}>
              <path
                d="M7.5 14V2C7.5 1.72386 7.72386 1.5 8 1.5C8.27614 1.5 8.5 1.72386 8.5 2V14C8.5 14.2761 8.27614 14.5 8 14.5C7.72386 14.5 7.5 14.2761 7.5 14Z"
                fill="currentColor"
              />
              <path
                d="M13.5 3.33333C13.5 2.8731 13.1269 2.5 12.6667 2.5H3.33333C2.8731 2.5 2.5 2.8731 2.5 3.33333V12.6667C2.5 13.1269 2.8731 13.5 3.33333 13.5H12.6667C13.1269 13.5 13.5 13.1269 13.5 12.6667V3.33333ZM14.5 12.6667C14.5 13.6792 13.6792 14.5 12.6667 14.5H3.33333C2.32081 14.5 1.5 13.6792 1.5 12.6667V3.33333C1.5 2.32081 2.32081 1.5 3.33333 1.5H12.6667C13.6792 1.5 14.5 2.32081 14.5 3.33333V12.6667Z"
                fill="currentColor"
              />
              <path
                d="M14 5.5C14.2761 5.5 14.5 5.72386 14.5 6C14.5 6.27614 14.2761 6.5 14 6.5H2C1.72386 6.5 1.5 6.27614 1.5 6C1.5 5.72386 1.72386 5.5 2 5.5H14Z"
                fill="currentColor"
              />
              <path
                d="M14 9.5C14.2761 9.5 14.5 9.72386 14.5 10C14.5 10.2761 14.2761 10.5 14 10.5H2C1.72386 10.5 1.5 10.2761 1.5 10C1.5 9.72386 1.72386 9.5 2 9.5H14Z"
                fill="currentColor"
              />
            </SvgIcon>
          </ViewToggleButton>
        </span>
      </Tooltip>

      <Tooltip title={`${t('List view')}${tooltipSuffix}`}>
        <span>
          <ViewToggleButton
            active={viewMode === 'list'}
            disabled={disabled}
            onClick={() => onViewModeChange?.('list')}
            data-testid="list-view-button"
          >
            <SvgIcon viewBox="0 0 16 16" sx={{ width: '1rem', height: '1rem' }}>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.6667 1.5C13.6792 1.5 14.5 2.32081 14.5 3.33333V12.6667C14.5 13.6792 13.6792 14.5 12.6667 14.5H3.33333C2.32081 14.5 1.5 13.6792 1.5 12.6667V3.33333C1.5 2.32081 2.32081 1.5 3.33333 1.5H12.6667ZM2.5 10.5V12.6667C2.5 13.1269 2.8731 13.5 3.33333 13.5H12.6667C13.1269 13.5 13.5 13.1269 13.5 12.6667V10.5H2.5ZM2.5 9.5H13.5V6.5H2.5V9.5ZM3.33333 2.5C2.8731 2.5 2.5 2.8731 2.5 3.33333V5.5H13.5V3.33333C13.5 2.8731 13.1269 2.5 12.6667 2.5H3.33333Z"
                fill="currentColor"
              />
            </SvgIcon>
          </ViewToggleButton>
        </span>
      </Tooltip>
    </ViewToggleContainer>
  );
};

export default ToolbarViewToggle;
